<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <!-- <div class="police-badge">警徽logo</div> -->
      <div class="filing-info">
        <!-- <strong></strong> -->
        <span>许可证编号：<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备2025174950号-2</a></span>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.site-footer {
  // margin-top: 32px;
  border-top: 1px solid rgba(17, 88, 214, 0.08);
  background: rgba(255, 255, 255, 0.92);
}

.site-footer__inner {
  width: min(1400px, calc(100% - 48px));
  margin: 0 auto;
  padding: 22px 0 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  color: var(--text-secondary);
}

.police-badge {
  width: 68px;
  height: 68px;
  border-radius: 20px;
  display: grid;
  place-items: center;
  font-size: 12px;
  color: #fff;
  background: linear-gradient(135deg, #1649b8, #0c2c7a);
  box-shadow: 0 14px 28px rgba(12, 44, 122, 0.18);
}

.filing-info {
  display: flex;
  // flex-direction: column;
  gap: 6px;
}

.filing-info strong {
  font-size: 14px;
  color: var(--text-main);
}

.filing-info span {
  font-size: 13px;
}

@media (max-width: 768px) {
  .site-footer__inner {
    width: calc(100% - 24px);
    flex-direction: column;
    text-align: center;
  }
}
</style>
